var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerminateGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.82828C6 4.96296 5.95286 5.07744 5.85859 5.17172L5.17172 5.85859C5.07744 5.95286 4.96296 6 4.82828 6C4.6936 6 4.57912 5.95286 4.48485 5.85859L3 4.37374L1.51515 5.85859C1.42088 5.95286 1.3064 6 1.17172 6C1.03704 6 0.922559 5.95286 0.828283 5.85859L0.141414 5.17172C0.0471381 5.07744 0 4.96296 0 4.82828C0 4.6936 0.0471381 4.57912 0.141414 4.48485L1.62626 3L0.141414 1.51515C0.0471381 1.42088 0 1.3064 0 1.17172C0 1.03704 0.0471381 0.922559 0.141414 0.828283L0.828283 0.141414C0.922559 0.0471381 1.03704 0 1.17172 0C1.3064 0 1.42088 0.0471381 1.51515 0.141414L3 1.62626L4.48485 0.141414C4.57912 0.0471381 4.6936 0 4.82828 0C4.96296 0 5.07744 0.0471381 5.17172 0.141414L5.85859 0.828283C5.95286 0.922559 6 1.03704 6 1.17172C6 1.3064 5.95286 1.42088 5.85859 1.51515L4.37374 3L5.85859 4.48485C5.95286 4.57912 6 4.6936 6 4.82828Z",
    fill: "#D01A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminateGroup);
export default __webpack_public_path__ + "static/media/TerminateGroup.fde93972c4d36aeffba91c774f8a77a2.svg";
export { ForwardRef as ReactComponent };